import { render, staticRenderFns } from "./CommunityEditor.vue?vue&type=template&id=2a98f24c&scoped=true&"
import script from "./CommunityEditor.vue?vue&type=script&lang=ts&"
export * from "./CommunityEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommunityEditor.vue?vue&type=style&index=0&id=2a98f24c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a98f24c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VSelect,VTextField,VTextarea})
